import React from 'react';
import { Bell, CalendarClock, Download, Search, UserRoundCog, UsersRound, X } from 'lucide-react';

const views = [
  ['all', 'All'], ['available', 'Available'], ['break', 'On Break'],
  ['meeting', 'Meeting'], ['logged-out', 'Logged Out'], ['exceeded', 'Break Exceeded']
];

export default function DashboardControls({ search, onSearch, counts, activeView, onView,
  canManage, onViewAll, onDownload, onManageUsers, onManageShifts,
  notificationCount, notificationsOpen, onNotifications }) {
  const actions = [
    { label: 'View All Agents', text: 'View Agents', icon: UsersRound, onClick: onViewAll },
    ...(canManage ? [
      { label: 'Download Report', text: 'Download', icon: Download, onClick: onDownload },
      { label: 'Manage Users', icon: UserRoundCog, onClick: onManageUsers },
      { label: 'Shift Management', text: 'Shifts', icon: CalendarClock, onClick: onManageShifts }
    ] : [])
  ];
  return (
    <section className="floor-controls" aria-labelledby="floor-controls-title">
      <div className="floor-controls-heading">
        <h2 id="floor-controls-title">Live Overview</h2>
        <button className="floor-notifications" type="button" onClick={onNotifications}
          aria-expanded={notificationsOpen} aria-label={`Notifications (${notificationCount})`}>
          <Bell size={16} aria-hidden="true" /><span>Notifications</span><b>{notificationCount}</b>
        </button>
      </div>
      <label className="floor-search" htmlFor="floor-agent-search">
        <Search size={16} aria-hidden="true" />
        <input id="floor-agent-search" type="search" aria-label="Search Agent" value={search}
          onChange={(event) => onSearch(event.target.value)} placeholder="Search by name, status, extension..." />
        {search && <button type="button" aria-label="Clear search" title="Clear search" onClick={() => onSearch('')}>
          <X size={16} aria-hidden="true" />
        </button>}
      </label>
      <nav className="floor-status-chips" aria-label="Agent status navigation">
        {views.map(([key, label]) => (
          <button key={key} type="button" className={`floor-status-chip tone-${key}`}
            aria-pressed={activeView === key} onClick={() => onView(key)}>
            <i aria-hidden="true" /><span>{label}</span><b>{counts[key]}</b>
          </button>
        ))}
      </nav>
      <div className="floor-quick-actions">
        <h3>Quick Actions</h3>
        <div className="floor-action-grid">
          {actions.map(({ label, text, icon: Icon, onClick }) => (
            <button key={label} type="button" onClick={onClick} aria-label={label} title={label}>
              <Icon size={16} aria-hidden="true" /><span>{text || label}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
